<template>
  <div class="wrapper wrapper-preview">
    <div>
      <div class="frm-row">
        <div class="frm-item grow left">
          <!-- ****  メッセージ表示領域 **** -->
          <p class="errMsg title-ico ico-warning" v-show="errors != ''">
            <ErrorMessage :errors="errors"></ErrorMessage>
          </p>
        </div>
      </div>
      <div class="frm-row">
        <span class="frm-label">ファイル名</span>
        <select
          class="frm-select frm-size-xl"
          v-model="investment"
          @change="handleChange"
          :disabled="isDisabled"
          tabindex="0"
          ref="pdfList"
        >
          <option
            v-for="item in pdfDropDownList"
            :key="item.value"
            :value="item.value"
          >
            {{ item.name }}
          </option>
        </select>
        <div class="frm-item grow right">
          <div class="frm-row">
            <div class="frm-item" v-if="isShowStatus">
              <span class="frm-label">収集状況</span>
              <span class="frm-label">
                <img
                  v-if="status == documentStatusInfoList.Unrequested.code"
                  src="@/assets/images/TDSDC/label_request_m1.png"
                  alt="未依頼"
                />
                <img
                  v-else-if="status == documentStatusInfoList.Requested.code"
                  src="@/assets/images/TDSDC/label_request_m2.png"
                  alt="依頼済、未提出"
                />
                <img
                  v-else-if="status == documentStatusInfoList.Waiting.code"
                  src="@/assets/images/TDSDC/label_request2-2.png"
                  alt="依頼済(書類提出待)"
                />
                <img
                  v-else-if="status == documentStatusInfoList.AnyCollected.code"
                  src="@/assets/images/TDSDC/label_request2-3.png"
                  alt="依頼済(一部提出済)、一部提出済"
                />
                <img
                  v-else-if="status == documentStatusInfoList.Collected.code"
                  src="@/assets/images/TDSDC/label_request_m3.png"
                  alt="収集済、提出済"
                />
                <img
                  v-else-if="status == documentStatusInfoList.NotSubmit.code"
                  src="@/assets/images/TDSDC/label_request3-2.png"
                  alt="収集済(提出無し)"
                />
                <img
                  v-else-if="status == documentStatusInfoList.ReRequested.code"
                  src="@/assets/images/TDSDC/label_request_m4.png"
                  alt="再依頼、再通知"
                />
                <img
                  v-else-if="status == documentStatusInfoList.ReWaiting.code"
                  src="@/assets/images/TDSDC/label_request4-2.png"
                  alt="再依頼(書類提出待)"
                />
                <img
                  v-else-if="
                    status == documentStatusInfoList.ReAnyCollected.code
                  "
                  src="@/assets/images/TDSDC/label_request4-3.png"
                  alt="再依頼(一部提出済)、一部提出済"
                />
                <img
                  v-else-if="status == documentStatusInfoList.Checked.code"
                  src="@/assets/images/TDSDC/label_request_m5.png"
                  alt="確認済"
                />
              </span>
              <button
                class="frm-btn"
                type="button"
                @click="cancelConfirmed"
                v-show="isShowBtnStatusUpdate"
                :disabled="isStatusChangeDisabled"
              >
                {{ statusText }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="frm-row preview-control">
        <label>
          <font color="red"
            >※PDFに変換して表示しているため実際のイメージと異なる場合がございます。</font
          >
        </label>
      </div>
    </div>
    <!-- preview-area -->
    <div class="preview-area">
      <iframe
        :src="pdfUrl"
        type="application/pdf"
        style="width: 100%; height: 100%; display: block"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
        border="0"
        scrolling="no"
      ></iframe>
    </div>
    <!-- preview-area // -->
  </div>
</template>

<script>
import _ from "lodash";
import Common from "@/util/common.js";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { DOCUMENT_STATUS_INFO } from "@/util/enum.js";
import { DOCUMENT_COLLECTMODE_LIST } from "@/util/data.js";
import { getPDFApi } from "@/api/common_download";
import { mapMutations } from "vuex";

import { API_DisplayFileConfirmationScreen, API_ToPDF, API_UpdateStatus } from '@/api/Modules/DC01/STDSDC01C08.js'

export default {
  name: "STDSDC01C08FileConfirmation",
  components: {
    ErrorMessage,
  },
  data() {
    return {
      fileIDList: [],
      fileNameList: [],
      pdfDropDownList: [],
      investment: 1,
      pdfUrl: "",
      showFlag: false,
      errors: [],
      collectMode: 0,
      status: 0,
      isShowStatus: false,
      isShowBtnStatusUpdate: true,
      documentStatusInfoList: DOCUMENT_STATUS_INFO,
      collectModeList: DOCUMENT_COLLECTMODE_LIST,
      taxFilingDataId: "",
      documentIds: [],
      fileNameListDropDisable: true,
      isStatusChangeDisabled: false, // ステータス変更ボタン_活性状態
    };
  },
  mounted() {
    // 「処理中」表示
    this.processDialogue(true);
    API_DisplayFileConfirmationScreen().then(
      async (response) => {
        //正常の場合
        if (_.eq(response.result, "0000") || _.eq(response.result, "0001")) {
          //  書類収集方法
          this.collectMode = response.stdsdC01C08Info.collectMode;
          // 書類収集状況
          this.status = response.stdsdC01C08Info.documentStatus;
          // ファイルIDリスト
          this.fileIDList = response.stdsdC01C08Info.fileIDList;
          // ファイル名リスト
          this.fileNameList = response.stdsdC01C08Info.fileNameList;
          // 申告書等データID
          this.taxFilingDataId = response.stdsdC01C08Info.taxFilingDataId;
          // 書類ID
          this.documentIds.push(response.stdsdC01C08Info.documentId);
          this.errors = [];
          if (response.errorCD == "MTCL1041") {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
            this.pdfUrl = "";
          } else if (response.errorCD == "MTCL1105") {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, ["表示"])
              )
            );
          } else {
            // 表示するPDFのファイルパス
            const res = await getPDFApi(response.file, response.uniqueKey);
            if (_.eq(res.result, "0000")) {
              this.pdfUrl = res.objURL;
            } else {
              // エラー表示
              this.errors.push(
                Common.createError(
                  res.errorCD,
                  Common.getMessage(res.errorCD, [])
                )
              );
            }
          }
          // 処理完了＞リスト活性
          this.fileNameListDropDisable = false;

          // 書類収集状況等の表示設定
          if (
            this.status &&
            this.status != 0 &&
            this.status != 99 &&
            this.collectMode != this.collectModeList[3].code
          ) {
            this.isShowStatus = true;
          } else {
            this.isShowStatus = false;
          }

          // ファイル選択プルダウンの設定
          this.investment = this.fileIDList[0];
          this.fileIDList.forEach((value, index, array) => {
            const item = {
              name: this.fileNameList[index],
              value: value,
            };
            this.pdfDropDownList.push(item);
          });

          this.$nextTick(function() {
            this.initFocus();
          });
        } else {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }

        // 「処理中」非表示
        this.processDialogue(false);
      }
    );
  },
  computed: {
    // **********************************************
    // * ファイル名非活性、活性
    // **********************************************
    isDisabled() {
      return this.pdfDropDownList.length <= 1 || this.fileNameListDropDisable
        ? true
        : false;
    },
    // **********************************************
    // *ステータスの更新
    // **********************************************
    statusText() {
      // 収集済
      if (
        this.status == this.documentStatusInfoList.Collected.code ||
        this.status == this.documentStatusInfoList.NotSubmit.code
      ) {
        this.switchStausUpdateBtn(true);
        // "MTCL2038": "確認済に変更する",
        return Common.getMessage("MTCL2038", []);
      }
      // 確認済
      else if (this.status == this.documentStatusInfoList.Checked.code) {
        this.switchStausUpdateBtn(true);
        // "MTCL2037": "確認済を解除する",
        return Common.getMessage("MTCL2037", []);
      } else {
        // 上記以外のステータスはステータスの変更ボタンを非表示に
        this.switchStausUpdateBtn(false);
        return "";
      }
    },
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue"]),
    // **********************************************
    // * プルダウンを切り替える
    // **********************************************
    handleChange(e) {
      this.errors = [];
      // 処理開始＞リスト非活性
      this.fileNameListDropDisable = true;
      this.investment = e.target.value;
      // ファイル名取得
      const fileName = this.pdfDropDownList[e.target.options.selectedIndex]
        .name;
      // ファイルID取得
      const fileId = this.pdfDropDownList[e.target.options.selectedIndex].value;

      // ファイル拡張子取得
      const extension = fileName
        .substring(fileName.lastIndexOf(".") + 1)
        .toLowerCase();
      const mimetype = [
        "pdf",
        "csv",
        "xml",
        "txt",
        "xlsx",
        "docx",
        "jpg",
        "png",
        "gif",
        "bmp",
      ];
      // 許可しない拡張子の場合
      if (!_.includes(mimetype, extension)) {
        this.errors.push(
          Common.createError("MTCL1041", Common.getMessage("MTCL1041", []))
        );
        this.pdfUrl = "";
        // 処理完了＞リスト活性
        this.fileNameListDropDisable = false;
        return;
      }

      // パラメータ準備
      let params = {
        File: fileName,
        FileId: fileId,
      };

      // ファイル名プルダウン 非活性化
      this.isDisabled = true;
      // 「処理中」表示
      this.processDialogue(true);
      API_ToPDF(params).then(async (response) => {
        //正常の場合
        if (_.eq(response.result, "0000") || _.eq(response.result, "0001")) {
          if (response.errorCD == "MTCL1105") {
            this.pdfUrl = "";
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, ["表示"])
              )
            );
          } else {
            // 表示するPDFのファイルパス
            const res = await getPDFApi(response.file, response.uniqueKey);
            if (_.eq(res.result, "0000")) {
              this.pdfUrl = res.objURL;
            } else {
              // エラー表示
              this.errors.push(
                Common.createError(
                  res.errorCD,
                  Common.getMessage(res.errorCD, [])
                )
              );
            }
          }
          // 処理完了＞リスト活性
          this.fileNameListDropDisable = false;
        } else {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
        // ファイル名プルダウン 活性化
        this.isDisabled = false;
        // 「処理中」非表示
        this.processDialogue(false);
      });
    },
    // **********************************************
    // * 「確認済」、「収集済」を切り替える
    // **********************************************
    cancelConfirmed() {
      var changeStatus = 0;
      if (
        this.status == this.documentStatusInfoList.Collected.code ||
        this.status == this.documentStatusInfoList.NotSubmit.code
      ) {
        changeStatus = this.documentStatusInfoList.Checked.code;
      } else {
        changeStatus = this.documentStatusInfoList.Collected.code;
      }
      let param = {
        Status: changeStatus,
        DocumentIds: this.documentIds,
        TaxFilingDataId: this.taxFilingDataId,
      };

      // ステータス変更ボタン 非活性化
      this.isStatusChangeDisabled = true;
      API_UpdateStatus(param).then((response) => {
        //正常の場合
        if (_.eq(response.result, "0000")) {
          this.status = changeStatus;
          // 親画面のリロード
          window.opener.location.reload();
        } else {
          //上記以外の場合
          this.errors = [];
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
        // ステータス変更ボタン 活性化
        this.isStatusChangeDisabled = false;
      });
    },
    // **********************************************
    // * ステータスの変更ボタン「表示」、「非表示」切り替え
    // **********************************************
    switchStausUpdateBtn(showFlag) {
      this.isShowBtnStatusUpdate = showFlag;
    },
    // **********************************************
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.pdfList.focus();
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.preview-area {
  flex-grow: 1;
}
</style>
